// extracted by mini-css-extract-plugin
export var infoRow = "_qh-2";
export var labelContainer = "_qh-0";
export var rightInfo = "_qh-1";